import { TileType } from "./TileType";
import { ButtonDataType } from "./ButtonDataType";
import { emptyPayNowTileType, PayNowTileType } from "./PayNowTileType";

export type CaseDetailsType = {
  buttons: ButtonDataType[];
  payNowTile: PayNowTileType;
  tiles: TileType[];
  tilesColumnsNum: number;
};

export const emptyCaseDetailsType: CaseDetailsType = {
    buttons: [],
    payNowTile: {...emptyPayNowTileType},
    tiles: [],
    tilesColumnsNum: 0
}